export const FIELD_VISIBILITY_OPERATORS = `
    query _ {
        comparator_list {
            id
            comparator_name
        }
    }
`;
